import { TabProps } from "@/components/SettingsSidepanel/settings.types.ts";
import SettingsSheetHeader from "@/components/SettingsSidepanel/SettingsSheetHeader.tsx";
import SettingsSheetProfile from "@/components/SettingsSidepanel/SettingsSheetProfile.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import SlackIcon from "@/assets/slack.svg";
import { Button } from "@/components/ui/button.tsx";
import { getInstallSlackAppAuthorizationUrl } from "@/env";

const IntegrationTab: React.FC<TabProps> = ({ onRequestClose }) => {
  return (
    <>
      <SettingsSheetHeader
        onRequestClose={onRequestClose}
        title="Integration"
      />
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 p-4 rounded-[16px] border border-accent-foreground text-sm">
          <SettingsSheetProfile />

          <Separator />

          <div className="border rounded-2xl p-3 space-y-3 dark:bg-[#081C38] bg-accent ">
            <div className="flex justify-between items-center">
              <img
                src={SlackIcon}
                alt="Slack"
                className="invert dark:invert-0"
              />

              <Button
                variant="paint"
                onClick={() =>
                  window.open(getInstallSlackAppAuthorizationUrl())
                }
              >
                Install
              </Button>
            </div>

            <div className="text-secondary-foreground">
              You can now request for bids from slack. It's super easy to use.
              Just install the app and use the command "/hotspring" to get
              started.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntegrationTab;
